import React from 'react';
import { UseFormRegister, Path, FieldErrors } from 'react-hook-form';
import { AddressInformationType } from '../types';
import { styles } from '../../../styles';
import { states } from '../../../_sharedData/states';
import ErrorMessage from './error-message';

type StateDropdownProps = {
	register: UseFormRegister<AddressInformationType>;
	name: Path<AddressInformationType>;
	errors: FieldErrors<AddressInformationType>;
	language: string;
};

export default function StateDropdown({ register, name, errors, language }: StateDropdownProps) {
	return (
		<div>
			<div className="relative">
				<select
					className={`${styles.mediumInput} ${errors[name] ? styles.error : ''} overflow-auto text-sm font-medium`}
					id={name}
					{...register(name)}
				>
					<option value="">{language === 'en' ? 'Choose...' : 'Elige...'}</option>
					{states.map((state) => (
						<option key={state} value={state}>
							{state}
						</option>
					))}
				</select>
			</div>
			{errors[name] ? (
				<div className="max-w-56">
					<ErrorMessage currentStep="addressInformation" value="state" />
				</div>
			) : null}
		</div>
	);
}
